<template>
  <div>
    <iframe :src="content"></iframe>
  </div>
</template>
<script>
export default {
  props: ['content'],
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
div > iframe{
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/IFrameWidget.vue